module.exports = __webpack_public_path__ + "static/media/humza icons-08.a5d34331.svg";